var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    !_vm.hasBeenSubmitted
      ? _c(
          "form",
          {
            ref: "form",
            staticClass: "form",
            class: { "form--submitting": _vm.isSubmitting },
            attrs: { autocomplete: "off" },
            on: {
              submit: function($event) {
                $event.preventDefault()
                return _vm.submitForm.apply(null, arguments)
              }
            }
          },
          [
            _vm.isInitializing
              ? _c("fragment", [
                  _c("div", { staticClass: "form__row" }, [
                    _c("div", { staticClass: "form__field-wrap" }, [
                      _c("div", { staticClass: "form__placeholder-input" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form__row" }, [
                    _c("div", { staticClass: "form__field-wrap" }, [
                      _c("div", { staticClass: "form__placeholder-input" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form__row form__row--policy" }, [
                    _c("div", { staticClass: "form__field-wrap" }, [
                      _c("div", { staticClass: "form__placeholder-checkbox" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form__row form__row--submit" }, [
                    _c("div", { staticClass: "form__field-wrap" }, [
                      _c("div", { staticClass: "form__placeholder-button" })
                    ])
                  ])
                ])
              : _c(
                  "fragment",
                  [
                    _vm._l(_vm.filteredCFields, function(field, index) {
                      return _c(
                        "fragment",
                        { key: index },
                        [
                          field.type === "header"
                            ? [
                                _c("span", { staticClass: "form__headline" }, [
                                  _vm._v(_vm._s(field.header))
                                ])
                              ]
                            : field.type === "fullname" ||
                              field.type === "firstname" ||
                              field.type === "lastname" ||
                              field.type === "customer_account"
                            ? [
                                _c("div", { staticClass: "form__row" }, [
                                  field.header
                                    ? _c(
                                        "label",
                                        {
                                          staticClass: "form__label",
                                          attrs: {
                                            for: _vm.getUniqueId(field.type)
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.getFieldHeader(field))
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("input", {
                                    staticClass: "form__input",
                                    attrs: {
                                      id: _vm.getUniqueId(field.type),
                                      name: field.type,
                                      type: "text",
                                      placeholder: _vm.getFieldTitle(
                                        field,
                                        true
                                      ),
                                      title: _vm.getFieldTitle(field),
                                      "aria-required": field.required,
                                      required: field.required
                                    }
                                  })
                                ])
                              ]
                            : field.type === "email"
                            ? [
                                _c("div", { staticClass: "form__row" }, [
                                  field.header
                                    ? _c(
                                        "label",
                                        {
                                          staticClass: "form__label",
                                          attrs: {
                                            for: _vm.getUniqueId(field.type)
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.getFieldHeader(field))
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.email,
                                        expression: "email"
                                      }
                                    ],
                                    staticClass: "form__input",
                                    attrs: {
                                      id: _vm.getUniqueId(field.type),
                                      name: field.type,
                                      type: "email",
                                      placeholder: _vm.getFieldTitle(
                                        field,
                                        true
                                      ),
                                      title: _vm.getFieldTitle(field),
                                      "aria-required": field.required,
                                      required: field.required
                                    },
                                    domProps: { value: _vm.email },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.email = $event.target.value
                                      }
                                    }
                                  })
                                ])
                              ]
                            : field.type === "phone"
                            ? [
                                _c("div", { staticClass: "form__row" }, [
                                  field.header
                                    ? _c(
                                        "label",
                                        {
                                          staticClass: "form__label",
                                          attrs: {
                                            for: _vm.getUniqueId(field.type)
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.getFieldHeader(field))
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("input", {
                                    staticClass: "form__input",
                                    attrs: {
                                      id: _vm.getUniqueId(field.type),
                                      name: field.type,
                                      type: "tel",
                                      placeholder: _vm.getFieldTitle(
                                        field,
                                        true
                                      ),
                                      title: _vm.getFieldTitle(field),
                                      "aria-required": field.required,
                                      required: field.required
                                    }
                                  })
                                ])
                              ]
                            : field.type === "text"
                            ? [
                                _c("div", { staticClass: "form__row" }, [
                                  field.header
                                    ? _c(
                                        "label",
                                        {
                                          staticClass: "form__label",
                                          attrs: {
                                            for: _vm.getUniqueId(field.id)
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.getFieldHeader(field))
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("input", {
                                    staticClass: "form__input",
                                    attrs: {
                                      id: _vm.getUniqueId(field.id),
                                      name: field.id,
                                      type: "text",
                                      "data-custom-field": "",
                                      placeholder: _vm.getFieldTitle(
                                        field,
                                        true
                                      ),
                                      title: _vm.getFieldTitle(field),
                                      "aria-required": field.required,
                                      required: field.required
                                    }
                                  })
                                ])
                              ]
                            : field.type === "textarea"
                            ? [
                                _c("div", { staticClass: "form__row" }, [
                                  field.header
                                    ? _c(
                                        "label",
                                        {
                                          staticClass: "form__label",
                                          attrs: {
                                            for: _vm.getUniqueId(field.id)
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.getFieldHeader(field))
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("textarea", {
                                    staticClass: "form__textarea",
                                    attrs: {
                                      id: _vm.getUniqueId(field.id),
                                      name: field.id,
                                      "data-custom-field": "",
                                      placeholder: _vm.getFieldTitle(
                                        field,
                                        true
                                      ),
                                      title: _vm.getFieldTitle(field),
                                      "aria-required": field.required,
                                      required: field.required
                                    }
                                  })
                                ])
                              ]
                            : field.type === "dropdown"
                            ? [
                                field.options
                                  ? _c("div", { staticClass: "form__row" }, [
                                      field.header
                                        ? _c(
                                            "label",
                                            {
                                              staticClass: "form__label",
                                              attrs: {
                                                for: _vm.getUniqueId(field.id)
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getFieldHeader(field)
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "form__select-wrap" },
                                        [
                                          _c(
                                            "select",
                                            {
                                              staticClass: "form__select",
                                              attrs: {
                                                id: _vm.getUniqueId(field.id),
                                                name: field.id,
                                                "data-custom-field": "",
                                                title: _vm.getFieldTitle(field),
                                                "aria-required": field.required,
                                                required: field.required
                                              }
                                            },
                                            [
                                              _c(
                                                "option",
                                                {
                                                  attrs: { value: "" },
                                                  domProps: {
                                                    selected: !field.options.some(
                                                      function(o) {
                                                        return (
                                                          o.isDefault == "1"
                                                        )
                                                      }
                                                    )
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getFieldHeader(field)
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm._l(field.options, function(
                                                option,
                                                index
                                              ) {
                                                return _c(
                                                  "option",
                                                  {
                                                    key: index,
                                                    domProps: {
                                                      value: option.value,
                                                      selected:
                                                        option.isDefault == "1"
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(option.label))]
                                                )
                                              })
                                            ],
                                            2
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            : field.type === "listbox"
                            ? [
                                field.options
                                  ? _c("div", { staticClass: "form__row" }, [
                                      field.header
                                        ? _c(
                                            "label",
                                            {
                                              staticClass: "form__label",
                                              attrs: {
                                                for: _vm.getUniqueId(field.id)
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getFieldHeader(field)
                                                )
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "form__select-wrap form__select-wrap--multiple"
                                        },
                                        [
                                          _c(
                                            "select",
                                            {
                                              staticClass: "form__select",
                                              attrs: {
                                                id: _vm.getUniqueId(field.id),
                                                name: field.id,
                                                "data-custom-field": "",
                                                title: _vm.getFieldTitle(field),
                                                multiple: "",
                                                "aria-required": field.required,
                                                required: field.required
                                              }
                                            },
                                            _vm._l(field.options, function(
                                              option,
                                              index
                                            ) {
                                              return _c(
                                                "option",
                                                {
                                                  key: index,
                                                  domProps: {
                                                    value: option.value,
                                                    selected:
                                                      option.isDefault == "1"
                                                  }
                                                },
                                                [_vm._v(_vm._s(option.label))]
                                              )
                                            }),
                                            0
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            : field.type === "radio"
                            ? [
                                _c("div", { staticClass: "form__row" }, [
                                  field.header
                                    ? _c(
                                        "span",
                                        { staticClass: "form__label" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.getFieldHeader(field))
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "form__checkbox-radio-list"
                                    },
                                    _vm._l(field.options, function(
                                      option,
                                      index
                                    ) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass:
                                            "form__checkbox-radio-wrap"
                                        },
                                        [
                                          _c("input", {
                                            staticClass: "form__radio",
                                            attrs: {
                                              id: _vm.getUniqueId(
                                                field.id,
                                                option.id
                                              ),
                                              "data-custom-field": "",
                                              type: "radio",
                                              name: field.id,
                                              "aria-required": field.required,
                                              required: field.required
                                            },
                                            domProps: {
                                              value: option.value,
                                              checked: option.isDefault == "1"
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "form__checkbox-radio-label",
                                              attrs: {
                                                for: _vm.getUniqueId(
                                                  field.id,
                                                  option.id
                                                )
                                              }
                                            },
                                            [_vm._v(_vm._s(option.label))]
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                ])
                              ]
                            : field.type === "checkbox"
                            ? [
                                field.options
                                  ? _c(
                                      "div",
                                      { staticClass: "form__row" },
                                      [
                                        field.options.length > 1
                                          ? _c("fragment", [
                                              field.header
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass: "form__label"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getFieldHeader(
                                                            field
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form__checkbox-radio-list"
                                                },
                                                _vm._l(field.options, function(
                                                  option,
                                                  index
                                                ) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: index,
                                                      staticClass:
                                                        "form__checkbox-radio-wrap"
                                                    },
                                                    [
                                                      _c("input", {
                                                        staticClass:
                                                          "form__checkbox",
                                                        attrs: {
                                                          id: _vm.getUniqueId(
                                                            field.id,
                                                            option.id
                                                          ),
                                                          "data-custom-field":
                                                            "",
                                                          type: "checkbox",
                                                          name: field.id
                                                        },
                                                        domProps: {
                                                          value: option.value,
                                                          checked:
                                                            option.isDefault ==
                                                            "1"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "form__checkbox-radio-label",
                                                          attrs: {
                                                            for: _vm.getUniqueId(
                                                              field.id,
                                                              option.id
                                                            )
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(option.label)
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                }),
                                                0
                                              )
                                            ])
                                          : _c("fragment", [
                                              field.header
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass: "form__label"
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getFieldHeader(
                                                            field
                                                          )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form__checkbox-radio-wrap"
                                                },
                                                [
                                                  _c("input", {
                                                    staticClass:
                                                      "form__checkbox",
                                                    attrs: {
                                                      id: _vm.getUniqueId(
                                                        field.id,
                                                        field.options[0].id
                                                      ),
                                                      "data-custom-field": "",
                                                      type: "checkbox",
                                                      name: field.id,
                                                      "aria-required":
                                                        field.required,
                                                      required: field.required
                                                    },
                                                    domProps: {
                                                      value:
                                                        field.options[0].value,
                                                      checked:
                                                        field.options[0]
                                                          .isDefault == "1"
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass:
                                                        "form__checkbox-radio-label",
                                                      attrs: {
                                                        for: _vm.getUniqueId(
                                                          field.id,
                                                          field.options[0].id
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          field.options[0].label
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ])
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            : field.type === "policy"
                            ? [
                                field.options
                                  ? _c("div", { staticClass: "form__row" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "form__checkbox-radio-wrap form__checkbox-radio-wrap--policy"
                                        },
                                        [
                                          field.header
                                            ? _c(
                                                "span",
                                                { staticClass: "form__label" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getFieldHeader(field)
                                                    )
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "form__checkbox-radio-wrap"
                                            },
                                            [
                                              _c("input", {
                                                staticClass: "form__checkbox",
                                                attrs: {
                                                  id: _vm.getUniqueId(
                                                    field.id,
                                                    field.options[0].id
                                                  ),
                                                  "data-custom-field": "",
                                                  type: "checkbox",
                                                  name: field.id,
                                                  "aria-required":
                                                    field.required,
                                                  required: field.required
                                                },
                                                domProps: {
                                                  value: field.options[0].value,
                                                  checked:
                                                    field.options[0]
                                                      .isDefault == "1"
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  staticClass:
                                                    "form__checkbox-radio-label",
                                                  attrs: {
                                                    for: _vm.getUniqueId(
                                                      field.id,
                                                      field.options[0].id
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.getPolicyLabel(
                                                          field
                                                        )
                                                      )
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ]
                            : field.type === "hidden"
                            ? [
                                _c("input", {
                                  attrs: {
                                    id: _vm.getUniqueId(field.id),
                                    name: field.id,
                                    "data-custom-field": "",
                                    type: "hidden"
                                  },
                                  domProps: { value: field.default_text }
                                })
                              ]
                            : [
                                _c(
                                  "div",
                                  {
                                    staticClass: "form__row",
                                    staticStyle: {
                                      border: "2px dotted red",
                                      "font-size": "12px"
                                    }
                                  },
                                  [
                                    _c("p", [
                                      _vm._v("Field type not supported: "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(field.type) +
                                            " // " +
                                            _vm._s(field.header)
                                        )
                                      ])
                                    ])
                                  ]
                                )
                              ]
                        ],
                        2
                      )
                    }),
                    _vm._v(" "),
                    _vm.form.cfields
                      ? _c("div", { staticClass: "form__row" }, [
                          _c("div", { staticClass: "form__btn-wrap" }, [
                            _c(
                              "button",
                              {
                                staticClass: "form__btn btn",
                                attrs: { type: "submit" }
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "btn__icon" },
                                  [
                                    _c("SvgInline", {
                                      attrs: { name: "arrow" }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "btn__text" }, [
                                  _vm._v(_vm._s(_vm.form.button))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "btn__icon" },
                                  [
                                    _c("SvgInline", {
                                      attrs: { name: "arrow" }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "spinner-wrap",
                        class: { "spinner-wrap--absolute": _vm.isSubmitting },
                        attrs: {
                          "aria-hidden": _vm.isSubmitting ? "false" : "true"
                        }
                      },
                      [_c("div", { staticClass: "spinner" })]
                    )
                  ],
                  2
                )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.message
      ? _c(
          "div",
          {
            staticClass: "form__message",
            class: { "form__message--error": _vm.hasError }
          },
          [_vm._v(_vm._s(_vm.message))]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }